const HERO = "/images/emmy-hero.jpg";
const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

export default function HookPanel({ onCta }) {
  return (
    <section className="panel sec-hero" id="hero" data-i="0" data-testid="panel-hero">
      <div className="hook-grid">
        <div className="hook-text">
          <div className="hook-eyebrow reveal" style={d(0)}>
            Intentional Living • Culture • Motherhood
          </div>
          <h1 className="hook-headline reveal" style={d(1)}>
            Hi there, I'm <em>Emmy</em>
          </h1>
          <h2 className="hook-tagline reveal" style={d(2)}>
            Creating a life that supports the people you love—
            <br />
            and the person you're becoming.
          </h2>
          <p className="hook-sub reveal" style={d(3)}>
            Through thoughtful habits, meaningful routines, family adventures, and
            practical tools for building a life you genuinely enjoy living.
          </p>
          <div className="hook-cta-row reveal" style={d(4)}>
            <button className="btn-primary" data-testid="hook-newsletter-button" onClick={onCta}>
              Get My Weekly Letter →
            </button>
            <p className="cta-note">
              Every Thursday: intentional living notes, favorite finds &amp; honest reflections.
            </p>
          </div>
        </div>

        <div className="hook-photo reveal" style={d(2)}>
          <div className="frame">
            <img src={HERO} alt="Emmy with her son by the window" data-testid="hook-hero-image" />
          </div>
        </div>
      </div>

      <div className="scroll-cue reveal" style={d(5)}>
        <span>Scroll</span>
        <div className="line"></div>
      </div>
    </section>
  );
}
